/**
 * 开票记录
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/payCenter/billingRecordList' }"
        >开票记录</el-breadcrumb-item
      >
      <el-breadcrumb-item>开票申请</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 可开票金额 && 开票信息  -->
    <div class="block-detail-main">
      <el-form
        style="width: 100%"
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <div>
          <p class="info-title">购买方信息</p>
          <div style="display: flex; justify-content: flex-start">
            <div style="width: 40%">
              <el-form-item label="公司名称:">
                <div>{{ editForm.companyName }}</div>
              </el-form-item>
              <el-form-item label="税务登记号:">
                <div>{{ editForm.taxNumber }}</div>
              </el-form-item>
              <el-form-item label="开户行:">
                <div>{{ editForm.depositBank }}</div>
              </el-form-item>
              <el-form-item label="开户行账号:">
                <div>{{ editForm.depositBankAccount }}</div>
              </el-form-item>
              <el-form-item label="电话:">
                <div>{{ editForm.phone }}</div>
              </el-form-item>
              <el-form-item label="地址:">
                <div>{{ editForm.address }}</div>
              </el-form-item>
              <el-form-item label="收件人:">
                <el-input
                  size="small"
                  v-model="editForm.addresseeName"
                  auto-complete="off"
                  placeholder="请输入收件人"
                ></el-input>
              </el-form-item>
            </div>

            <div style="width: 40%">
              <el-form-item label="手机号:">
                <el-input
                  size="small"
                  v-model="editForm.mobile"
                  auto-complete="off"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="发送至邮箱:">
                <el-input
                  size="small"
                  v-model="editForm.sendToMail"
                  auto-complete="off"
                  placeholder="发送至邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子发票格式:">
                <el-select
                  size="small"
                  v-model="editForm.electronicInvoiceFormat"
                  placeholder="请选择"
                  class="full-width"
                >
                  <el-option
                    v-for="(val, index) in electronicInvoiceFormat_list"
                    :label="val.label"
                    :value="val.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="邮寄地址:">
                <el-select
                  size="small"
                  v-model="editForm.mailingAddress.province"
                  auto-complete="off"
                  placeholder="请选择"
                  @change="provinceChanged"
                  class="full-width"
                >
                  <el-option
                    v-for="(val, index) in province_list"
                    :label="val.name"
                    :value="val"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select
                  size="small"
                  v-model="editForm.mailingAddress.city"
                  auto-complete="off"
                  placeholder="请选择"
                  @change="cityChanged"
                  class="full-width"
                >
                  <el-option
                    v-for="(val, index) in city_list"
                    :label="val.name"
                    :value="val"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select
                  size="small"
                  v-model="editForm.mailingAddress.district"
                  auto-complete="off"
                  placeholder="请选择"
                  class="full-width"
                >
                  <el-option
                    v-for="(val, index) in district_list"
                    :label="val.name"
                    :value="val.name"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  size="small"
                  v-model="editForm.mailingAddress.detail"
                  auto-complete="off"
                  placeholder="请输入邮寄地址"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div>
          <p class="info-title">开票信息</p>
          <div style="width: 40%">
            <el-form-item label="销售方信息:">
              <div>{{ editForm.info }}</div>
            </el-form-item>
            <el-form-item label="开票类型:" prop="invoiceType">
              <el-select
                size="small"
                v-model="editForm.invoiceType"
                placeholder="请选择"
                class="full-width"
              >
                <el-option
                  v-for="(val, index) in invoiceType_list"
                  :label="val.invoiceTypeDesc"
                  :value="val.id"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票类目:" prop="invoiceCategory">
              <el-cascader
                size="small"
                v-model="selectedCategories"
                :options="categoriesOptions"
                :props="{ expandTrigger: 'hover' }"
                @change="handleChange"
                :show-all-levels="false"
                placeholder="请选择开票类目"
                filterable
                class="full-width"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="可开票金额:" prop="invoiceAmountinfo">
              <div style="color: red">
                {{
                  editForm.invoiceAmountinfo
                    ? editForm.invoiceAmountinfo.toFixed(2)
                    : "0.00"
                }}
              </div>
            </el-form-item>
            <el-form-item label="开票金额:" prop="invoiceAmount">
              <el-input
                size="small"
                v-model="editForm.invoiceAmount"
                auto-complete="off"
                placeholder="请输入可开票金额"
                class="full-width"
              ></el-input>
              <span class="btnNoBorderBlue" @click="editRecordVisible = true"
                >指定充值记录开票</span
              >
            </el-form-item>
            <el-form-item label="关联任务:" prop="taskId">
              <el-select
                size="small"
                multiple
                v-model="editForm.taskId"
                placeholder="请选择"
                class="full-width"
              >
                <el-option
                  v-for="(val, index) in taskId_list"
                  :label="val.taskName"
                  :value="val.taskId"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票备注:">
              <el-input
                size="small"
                v-model="editForm.remark"
                auto-complete="off"
                placeholder="请输入发票备注"
                class="full-width"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div
          style="
            display: flex;
            margin: 20px 20px 20px 0;
            justify-content: flex-end;
          "
        >
          <el-button
            size="small"
            type="primary"
            :loading="loading"
            class="title"
            @click="submitForm('editForm')"
            >提交申请</el-button
          >
        </div>
      </el-form>
    </div>
    <el-dialog
      title="指定充值记录"
      @open="getrechargeRecordsdata"
      :visible.sync="editRecordVisible"
      width="50%"
      @click="closeRecordDialog"
    >
      <!--列表-->
      <el-table
        height="400px"
        @selection-change="handleSelectionChange"
        :data="recordData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column prop="rechargeId" label="充值ID" width="200">
        </el-table-column>
        <el-table-column prop="rechargeAmount" label="充值金额" width="200">
          <template slot-scope="scope">
            <span>{{
              scope.row.rechargeAmount
                ? scope.row.rechargeAmount.toFixed(2)
                : "0.00"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="canInvoiceAmount" label="可开票金额" width="200">
          <template slot-scope="scope">
            <span>{{
              scope.row.canInvoiceAmount
                ? scope.row.canInvoiceAmount.toFixed(2)
                : "0.00"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalTime" label="到账时间" min-width="200">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="selectsub()"
          >确认指定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  invoiceRecords,
  invoiceInfo,
  exportinvoicerecords,
  invoicezip,
  deptList,
  createinvoicerecords,
  rechargeRecords,
  getinvoiceCategory,
  getinvoicetypes,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import { china } from "../../common/area.js";
export default {
  data() {
    return {
      multipleSelection: [],
      electronicInvoiceFormat_list: [
        {
          label: "PDF格式",
          value: 1,
        },
      ],
      taskId_list: [],
      invoiceType_list: [],
      invoiceCategory_list: [],
      selectedCategories: [], // 用户选择的一级和二级类目
      categoriesOptions: [],
      status_list: [
        {
          label: "处理中",
          value: 1,
        },
        {
          label: "成功",
          value: 2,
        },
        {
          label: "失败",
          value: 3,
        },
        {
          label: "作废",
          value: 4,
        },
      ],
      province_list: [],
      city_list: [],
      district_list: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      editRecordVisible: false,
      title: "添加",
      editForm: {
        companyName: "",
        taxNumber: "",
        depositBank: "",
        depositBankAccount: "",
        phone: "",
        address: "",
        addresseeName: "",
        mobile: "",
        sendToMail: "",
        electronicInvoiceFormat: "",
        mailingAddress: {
          city: "",
          district: "",
          province: "",
          detail: "",
        },
        recordType: 0,
        invoiceType: "",
        invoiceCategory: "",
        invoiceAmountinfo: "",
        invoiceAmount: "",
        taskId: [],
        remark: "",
        invoiceAmountinfo: "",
        info: "",
      },

      // rules表单验证
      rules: {
        invoiceType: [
          { required: true, message: "请选择开票类型", trigger: "manual" },
        ],
        invoiceCategory: [
          {
            required: true,
            message: "请选择开票类目",
            trigger: "manual",
          },
        ],
        taskId: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个关联任务",
            trigger: "manual",
          },
        ],
        invoiceAmountinfo: [
          { required: true, message: "请输入可开票金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value || parseFloat(value) <= 0) {
                callback(new Error("可开票金额必须大于0"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        invoiceAmount: [
          { required: true, message: "请输入开票金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error("请输入开票金额"));
              if (!value || parseFloat(value) <= 0) {
                callback(new Error("开票金额必须大于0"));
              }
              if (
                parseFloat(value) <= parseFloat(this.editForm.invoiceAmountinfo)
              ) {
                callback();
              } else {
                callback(new Error("开票金额不能大于可开票金额"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      recordData: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getInvoiceInfo();
    this.gettype1();
    this.gettype2();
    this.province_list = china;
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    fetchTaskList(invoiceCategory) {
      const params = {
        page: 1,
        pageSize: 100,
        taskId: [],
        taskName: "",
        status: "",
        startDate: "",
        endDate: "",
        invoiceCategory: invoiceCategory,
      };

      deptList(params)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.editForm.taskId = [];
            this.taskId_list = res.data.items;
            if (res.data.items && res.data.items.length == 0) {
              this.$message({
                type: "error",
                message: "没有对应类型的关联任务，请发布对应类型任务",
              });
              return;
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    provinceChanged(val) {
      this.editForm.mailingAddress.city = "";
      this.editForm.mailingAddress.district = "";
      this.city_list = val.city;
      this.editForm.mailingAddress.province = val.name;
    },
    cityChanged(val) {
      this.editForm.mailingAddress.district = "";
      this.district_list = val.area;
      this.editForm.mailingAddress.city = val.name;
    },
    selectsub() {
      // 检查是否选择了记录
      if (this.multipleSelection.length === 0) {
        this.$message.error("请选择至少一条记录");
        return;
      }

      // 获取选中的记录
      const selectedRecords = this.multipleSelection;

      // 将 rechargeId 用英文逗号连接
      const rechargeIds = selectedRecords
        .map((record) => record.rechargeId)
        .join(",");

      // 计算 rechargeAmount 的总和
      const totalRechargeAmount = selectedRecords
        .reduce((total, record) => {
          return total + (record.rechargeAmount || 0);
        }, 0)
        .toFixed(2);

      // 将结果存入表单字段
      this.editForm.rechargeId = rechargeIds;
      this.editForm.invoiceAmount = totalRechargeAmount;

      // 重新验证表单字段
      this.$refs["editForm"].validateField("invoiceAmount");

      // 关闭弹窗
      this.editRecordVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取公司列表
    getrechargeRecordsdata() {
      let params = {
        startDate: "",
        endDate: "",
        page: 1,
        pageSize: 100,
        varLable: "",
        varName: "",
        merchantName: "",
        rechargeStatus: 1, // 充值成功
        canInvoice: 1, // 可开票
      };

      rechargeRecords(params)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.recordData = res.data.items;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        recordStatus: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        recordId: "",
        merchantName: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    handleDetail(id) {
      this.$router.push({
        path: "/payCenter/invoiceDetail",
        query: {
          id: id,
        },
      });
    },
    exportdata() {
      exportinvoicerecords().then((res) => {
        window.open(res.data.downloadUrl);
      });
    },
    exportinvoice() {
      invoicezip().then((res) => {
        this.$router.push({ path: "/task/payExportList" });
      });
    },
    exportpath() {
      this.$router.push({ path: "/task/payExportList" });
    },
    getInvoiceInfo() {
      invoiceInfo()
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            let userInfo = JSON.parse(localStorage.getItem("user_info"));

            const data = res.data;
            this.editForm = {
              companyName: data.companyName || "",
              taxNumber: data.taxNumber || "",
              depositBank: data.depositBank || "",
              depositBankAccount: data.depositBankAccount || "",
              phone: data.phone || "",
              address: data.address || "",
              addresseeName: data.addresseeName || "",
              mobile: data.mobile || "",
              sendToMail: data.sendToMail || "",
              electronicInvoiceFormat: data.electronicInvoiceFormat || "",
              mailingAddress: {
                city: data.mailingAddress.city || "",
                district: data.mailingAddress.district || "",
                province: data.mailingAddress.province || "",
                detail: data.mailingAddress.detail || "",
              },
              invoiceType: data.invoiceType || "",
              invoiceCategory: data.invoiceCategory || [],
              invoiceAmountinfo: data.canInvoiceAmount || 0.0,
              invoiceAmount: data.invoiceAmount || "",
              taskId: data.taskId || [],
              remark: data.remark || "",
              electronicInvoiceFormat: data.electronicInvoiceFormat || 1,
              invoiceAmountinfo: data.canInvoiceAmount,
              info: userInfo.distributeCompanyName,
            };
          }
        })
        .catch((err) => {});
    },
    gettype1() {
      getinvoiceCategory().then((res) => {
        if (res.msg !== "success") {
          this.$message({
            type: "error",
            message: res.msg,
          });
          return;
        }
        if (res.data.length == 0) {
          this.$message({
            type: "error",
            message: "开票类目未配置，请联系管理员配置",
          });
          return;
        }
        this.categoriesOptions = res.data;
      });
    },
    gettype2() {
      getinvoicetypes().then((res) => {
        if (res.msg !== "success") {
          this.$message({
            type: "error",
            message: res.msg,
          });
          return;
        }
        if (res.data.items.length == 0) {
          this.$message({
            type: "error",
            message: "开票类型未配置，请联系管理员配置",
          });
          return;
        }
        this.invoiceType_list = res.data.items;
      });
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let params = {
            recordType: 0, //  正常申请发票
            isFrozen: 0, // 正常申请不冻结金额
            invoiceAmount: this.editForm.invoiceAmount,
            invoiceCategory: this.editForm.invoiceCategory,
            invoiceType: this.editForm.invoiceType,
            taskId: this.editForm.taskId ? this.editForm.taskId.join() : "",
            rechargeId: this.editForm.rechargeId,
            remark: this.editForm.remark,
            companyName: this.editForm.companyName,
            taxNumber: this.editForm.taxNumber,
            depositBank: this.editForm.depositBank,
            depositBankAccount: this.editForm.depositBankAccount,
            phone: this.editForm.phone,
            address: this.editForm.address,
            addresseeName: this.editForm.addresseeName,
            mobile: this.editForm.mobile,
            sendToMail: this.editForm.sendToMail,
            electronicInvoiceFormat: this.editForm.electronicInvoiceFormat,
            mailingAddress: this.editForm.mailingAddress,
          };
          createinvoicerecords(params)
            .then((res) => {
              this.loading = false;
              if (res.msg == "success") {
                this.$message({
                  type: "success",
                  message: "开票成功！",
                });
                this.$router.push({ path: "/payCenter/billingRecordList" });
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("操作失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    closeRecordDialog() {
      this.editRecordVisible = false;
    },
    handleChange(value) {
      if (value.length === 2) {
        this.editForm.invoiceCategory = value[1];
        // 获取响应任务
        this.fetchTaskList(this.editForm.invoiceCategory);
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.block-detail-main {
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
}
.info-block .info-title {
  width: 100%;
  padding: 0 32px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
}
.info-block .info-title .title {
  font-size: 16px;
}
.block-detail-main .block-detail-item .info-body {
  border-radius: 2px;
  padding: 24px 32px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100% - 58px);
}
.block-detail-main .block-detail-item .info-body .info-body-con {
  width: 320px;
  background: #6255f2;
  color: #fff;
  border-radius: 7px;
  padding: 30px 20px;
  box-sizing: border-box;
}
.block-detail-main
  .block-detail-item
  .info-body
  .info-body-con
  .info-body-title {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.block-detail-main
  .block-detail-item
  .info-body
  .info-body-con
  .info-body-amount {
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
  padding-bottom: 16px;
}
.block-detail-main
  .block-detail-item
  .info-body
  .info-body-con
  .info-body-amount
  span:first-child {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 4px;
}
.m_bot5 {
  margin-bottom: 15px;
}
.info-title {
  font-size: 16px;
  padding: 0 32px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
}
.btnNoBorderBlue {
  color: #1985ff;
  cursor: pointer;
  text-decoration: underline;
}
.full-width {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/applybilling.vue